import { supabase } from './supabase';

/**
 * POST JSON to one of our /api functions as the signed-in user.
 * Sends the Supabase access token so the function can tell who is calling
 * (api/_lib/auth.js). Throws an Error carrying the server's message on non-2xx.
 */
export async function postApi(path, body) {
  const { data: { session } } = await supabase.auth.getSession();

  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(session ? { Authorization: `Bearer ${session.access_token}` } : {}),
    },
    body: JSON.stringify(body),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    // Non-JSON body (e.g. a Vercel error page) — fall through to the generic message.
  }

  if (!response.ok) {
    const error = new Error(data?.error || `Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return data;
}
